module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-542.ec0e03c.woff2";